<template>
  <base-section
    id="team"
  >
    <base-section-heading title="Capital Humano">
      La esencia de Rosmar.
    </base-section-heading>

    <v-container>
      <v-row
        align="center"
        justify="center"
        class="mb-5"
      >
        <v-tabs
          v-model="tab"
          centered
        >
          <v-tab
            v-for="(t, i) in itemsTab"
            :key="i"
          >
            {{ t }}
          </v-tab>
        </v-tabs>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="(item, n) in selectedItems"
          :key="n"
          cols="12"
          md="3"
        >
          <base-hexagon-generator
            :img="item.image"
            :slug="item.slug"
            :local-img="true"
            base-url="team"
          />
          <div class="text-center body-1 text-uppercase">
            {{ item.title }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  // modificar
  export default {
    name: 'SectionProChart',

    data: () => ({
      tab: null,
    }),

    computed: {
      itemsTab () {
        return this.$store.state.staff.itemsTab || []
      },
      puestos () {
        return this.$store.state.staff.puestos || []
      },
      items () {
        return this.$store.state.staff.items || []
      },
      selectedItems () {
        if (!this.tab) {
          return this.items
        }
        return this.items.filter(i => i.dpto === this.tab)
      },
    },
  }
</script>
